import { ManagerRole } from '../../../../../../hooks/auth/usePermissions';

export default {
  form: {
    title: 'TeamManager hinzufügen',
    first_name: {
      label: 'Vornamen',
      placeholder: 'Walter',
    },
    last_name: {
      label: 'Nachname',
      placeholder: 'White',
    },
    city: {
      label: 'Stadt',
      placeholder: 'Bonn',
    },
    email: {
      label: 'Email',
      placeholder: 'thedanger@foodamigos.io',
    },
    roles: {
      label: 'Rolle',
      placeholder: 'Rolle auswählen',
      // Add-form label for store_admin sent with as_owner; other store admins keep "Admin".
      owner_option: 'Inhaber',
      options: {
        [ManagerRole.Admin]: 'Admin',
        [ManagerRole.Reseller]: 'Reseller',
        [ManagerRole.SalesManager]: 'Sales manager',
        [ManagerRole.SalesLeadership]: 'Sales lead',
        [ManagerRole.ContentManager]: 'Content manager',
        [ManagerRole.OnboardingManager]: 'Onboarding manager',
        [ManagerRole.MobileAppsManager]: 'Mobile apps manager',
        [ManagerRole.StoreAdmin]: 'Admin',
        [ManagerRole.StoreEmployee]: 'Employee',
        [ManagerRole.StoreOperator]: 'Operator',
        [ManagerRole.SDR]: 'SDR',
      },
      description: {
        [ManagerRole.StoreOperator]:
          '<strong>Operator:</strong> Du hast vollen Zugriff auf Verkäufe, Menü, Top-Artikel, Öffnungszeiten, Geschenkkarten, Reservierungen und Berichte für die dir zugewiesenen Unternehmen.',
        [ManagerRole.StoreEmployee]:
          '<strong>Employee:</strong> Du hast eingeschränkten Zugriff nur auf Reservierungen und Geschenkkarten.',
        [ManagerRole.StoreAdmin]:
          '<strong>Inhaber:</strong> Voller Zugriff auf ein Restaurant, inklusive Storefront, Steuereinstellungen, Marketing und Teamverwaltung. Erhält eine E-Mail mit den Zugangsdaten. Pro Restaurant gibt es einen Inhaber, der von anderen Teammitgliedern nicht bearbeitet oder entfernt werden kann.',
      },
    },
    companies: {
      label: 'Unternehmen',
      placeholder: 'Unternehmen auswählen',
      owner_placeholder: 'Restaurant auswählen',
      has_owner: 'Hat bereits einen Inhaber',
    },
  },
  fields: {
    email: 'Email',
    name: 'Name',
    roles: 'Role',
    status: 'Status',
    created_at: 'Erstellt',
    actions: 'Aktionen',
    companies: 'Unternehmen',
  },
  tags: {
    owner: 'Inhaber',
    operator: 'Operator',
    employee: 'Mitarbeiter',
  },
  no_owner: {
    title: '{{restaurant}} hat keinen Inhaber',
    description: 'Alles, was den Inhaber braucht, wartet, bis einer ausgewählt ist.',
  },
  search: {
    placeholder: 'Suche nach Name oder E-Mail',
  },
  buttons: {
    add_manager: 'Manager hinzufügen',
    actions: 'Aktionen',
    view_dashboard: 'Dashboard als dieses Manager anzeigen',
    login_as_manager: 'Als dieser Manager anmelden',
    delete: 'Dieses Manager löschen',
    resend_owner_invite: 'Einladung des Inhabers erneut senden',

    save_companies: 'Restaurants von {{name}} speichern',
    change_owner: '{{name}} als Inhaber entfernen',
    delete_named: '{{name}} löschen',
    choose_owner: 'Inhaber auswählen',
  },
  modals: {
    delete_manager: {
      title: 'Sind Sie sicher, dass Sie das Manager {{email}} löschen wollen?',
    },
    update_manager: {
      title: 'Manager {{email}} wirklich aktualisieren?',
    },
    resend_owner_invite: {
      title: 'Einladung erneut an {{email}} senden?',
      description:
        'Der Inhaber erhält per E-Mail ein neues Passwort. Sein bisheriges Passwort ist dann nicht mehr gültig.',
    },
  },
  toasts: {
    successfully_created_manager: 'Manager erfolgreich erstellt',
    owner_invited: '{{email}} wurde als Restaurantinhaber eingeladen und erhält die Zugangsdaten per E-Mail.',
    failed_to_load_data: 'Die Daten konnten nicht geladen werden, bitte aktualisieren Sie die Seite',
    failed_to_create_manager: 'TeamManager konnte nicht erstellt werden',
    failed_to_create_magic_link: 'Magischer Link konnte nicht erstellt werden',
    failed_to_delete_manager: 'Manager konnte nicht gelöscht werden',
    manager_got_deleted: 'Manager wurde gelöscht',
    successfully_updated_manager: 'Manager wurde erfolgreich aktualisiert',
    failed_to_update_manager: 'Manager konnte nicht aktualisiert werden',
    owner_invite_resent: 'Die Einladung wurde mit einem neuen Passwort erneut an {{email}} gesendet.',
    owner_invite_resend_cooling_down:
      'Die Einladung wurde gerade erneut gesendet. Bitte warten Sie einige Minuten, bevor Sie sie noch einmal senden.',
    failed_to_resend_owner_invite: 'Die Einladung konnte nicht erneut gesendet werden',

    owner_changed: '{{name}} ist jetzt Inhaber',
    owner_changed_new: '{{name}} ist jetzt Inhaber. Die Zugangsdaten wurden an {{email}} gesendet',
    owner_removed: '{{name}} ist nicht mehr Inhaber',
  },
};
